<div class="link-attachment-container">
  <form #linkForm="ngForm" (ngSubmit)="onSubmit(linkForm)" class="row p-3">
    <div class="col-12 col-md-5">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{ 'components.attachment.link-attachment.title' | translate }}</mat-label>
        <input matInput name="title" [(ngModel)]="model.title" required #title="ngModel">
        @if (title.invalid && (title.dirty || title.touched)) {
          <mat-error>{{ 'modals.modal-survey-details.errors.title-is-required' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-5">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{ 'components.attachment.link-attachment.link-url' | translate }}</mat-label>
        <input matInput name="link" [(ngModel)]="model.link" required pattern="https?://.+" #link="ngModel" placeholder="https://...">
        @if (link.invalid && (link.dirty || link.touched)) {
          <mat-error>{{ 'generic.error' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-2 d-flex align-items-center mb-3">
      <button mat-flat-button color="primary" type="submit" [disabled]="!linkForm.form.valid" class="w-100">
        <mat-icon class="mr-2">add</mat-icon>
        {{ 'generic.buttons.add' | translate }}
      </button>
    </div>
  </form>
</div>
